export interface CurrencyInfo {
  code: string
  symbol: string
  name: string
  precision: number
}

export const CURRENCIES: CurrencyInfo[] = [
  { code: 'EUR', symbol: '€',    name: 'Euro',              precision: 2 },
  { code: 'USD', symbol: '$',    name: 'US-Dollar',         precision: 2 },
  { code: 'GBP', symbol: '£',    name: 'Britisches Pfund',  precision: 2 },
  { code: 'CHF', symbol: 'CHF',  name: 'Schweizer Franken', precision: 2 },
  { code: 'JPY', symbol: '¥',    name: 'Japanischer Yen',   precision: 0 },
  { code: 'SEK', symbol: 'kr',   name: 'Schwedische Krone', precision: 2 },
  { code: 'BHD', symbol: '.د.ب', name: 'Bahrain-Dinar',     precision: 3 },
]

export const CURRENCY_MAP: Record<string, CurrencyInfo> = Object.fromEntries(
  CURRENCIES.map(c => [c.code, c])
)

export const CURRENCY_BASE_UNIT_DELTA_WARNING_THRESHOLD = 0.0001

export interface NormalizeCurrencyBaseUnitAmountOptions {
  context?: string
  warningThreshold?: number
  warn?: (message: string, details: Record<string, unknown>) => void
}

/**
 * Currency amounts are stored as integer base units. Fractional base units are
 * truncated towards zero so writes never persist values smaller than the
 * declared precision can represent.
 */
export function normalizeCurrencyBaseUnitAmount(
  amount: number,
  options: NormalizeCurrencyBaseUnitAmountOptions = {},
): number {
  if (!Number.isFinite(amount)) {
    return amount
  }

  const normalizedAmount = Math.trunc(amount)
  const discardedDelta = amount - normalizedAmount
  const warningThreshold = options.warningThreshold ?? CURRENCY_BASE_UNIT_DELTA_WARNING_THRESHOLD

  if (Math.abs(discardedDelta) > warningThreshold) {
    const warn = options.warn ?? console.warn
    warn('Currency amount lost fractional base units while being normalized', {
      amount,
      normalizedAmount,
      discardedDelta,
      warningThreshold,
      ...(options.context ? { context: options.context } : {}),
    })
  }

  return normalizedAmount
}

export function getDefaultPrecision(currencyCode: string): number | null {
  const info = CURRENCY_MAP[currencyCode]
  return info ? info.precision : null
}
